<link href='https://fonts.googleapis.com/css?family=Montserrat' rel='stylesheet'>
<div class="login-page">
  <div class="top-container" *ngIf="!isEdgeBrowser" style="font-family: 'Montserrat';">
    <div>
      Switch to <a href="microsoft-edge:https://gsd.innovasolutions.com/login"
      style="font-weight: 600; text-decoration: none;" 
      target="_blank" 
      rel="noopener noreferrer" >Microsoft Edge</a> for better experience
    </div>
  </div>
  <img src="../../../assets/images/login-page-image/Background_Competency.jpg" alt="Competencylogin"
    class="img-fluid login_background_image">
  <div class="container position-absolute login-container">
    <div class="row">
      <div class="col-md-5 offset-md-8">
        <a class="img-fluid"><img src="../../../assets/images/login-page-image/Innova_logo.svg" alt="Innova_logo"></a>
        <div class="pt-5 login-title" [@revealAnimation]>
          GLOBAL SOLUTIONS DELIVERY
        </div>
        <div class="pt-2 login-title-1" [@revealAnimation]>
          PORTAL
        </div>
        <div class="pt-2 login-description" [@revealAnimation]>
          A comprehensive collection of Competency, Skills, Artifactories, Case Studies, Account Planning, Which
          provides
          valuable insights to achieve specific objectives and goals of the Organization.
        </div>

        <div class="pt-3 mt-3 login-button" [@revealAnimation]>
          <a (click)="login('acs')"><span>Login with SSO</span></a>
          <a (click)="UnableToLogin()" class="ml-4"><span>Issue with login?</span></a>
        </div>


      </div>


    </div>


  </div>
</div>